module.exports = __webpack_public_path__ + "img/dfbee283dfd1b37c8aa0ffc8b6be8056.png";